/* eslint-disable @typescript-eslint/no-unused-vars */
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import SimpleBar from "simplebar-react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { FileDtoItemTypeEnum } from "generated/apiFiles";
import { getLoggedinUser } from "helpers/api_helper";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const FileDetail = (props: any) => {
  const { t } = useTranslation("translation", { keyPrefix: "FILE_MANAGER" });
  const authUser: any = getLoggedinUser();

  const { setActive, activeFile, setDeleteModal } = props;

  const [pdfModal, setPdfModal] = React.useState(false);
  const [videoModal, setVideoModal] = React.useState(false);
  const handleValidDate = (date: any) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };
  const [numPages, setNumPages] = React.useState<number>(0);
  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };
  const goToPrevPage = () => setCurrentPage((p) => Math.max(p - 1, 1));
  const goToNextPage = () => setCurrentPage((p) => Math.min(p + 1, numPages));

  const handleValidTime = (time: any) => {
    let orario = moment(new Date(time)).format("HH:mm");
    return orario;
  };

  const onClickDelete = (file: any) => {
    setDeleteModal(true);
  };

  return (
    <React.Fragment>
      <SimpleBar className="mx-n3 pt-3 px-3 file-detail-content-scroll">
        <div id="file-overview" className="h-100">
          <div className="d-flex h-100 flex-column">
            <div className="d-flex align-items-center pb-3 border-bottom border-bottom-dashed mb-3 gap-2">
              <h5 className="flex-grow-1 fw-semibold mb-0">
                {t("FILE:TITLE")}
              </h5>
              <div>
                <button
                  type="button"
                  className="btn btn-soft-danger btn-icon btn-sm fs-16 close-btn-overview"
                  onClick={() => setActive(false)}
                >
                  <i className="ri-close-fill align-bottom"></i>
                </button>
              </div>
            </div>

            <div className="pb-3 border-bottom border-bottom-dashed mb-3">
              <div className="file-details-box bg-light p-3 text-center rounded-3 border border-light mb-3">
                <div className="display-4 file-icon">
                  {activeFile?.type === "application/pdf" ? (
                    <i
                      className="ri-file-pdf-2-fill"
                      style={{ color: "red" }}
                    ></i>
                  ) : (
                    <i
                      className="ri-file-word-fill"
                      style={{ color: "#2b579a" }}
                    ></i>
                  )}
                </div>
              </div>
              <h5 style={{ maxWidth: "100%", whiteSpace: "normal", wordBreak: "break-word" }} className="fs-16 mb-1 file-name">{activeFile?.name}</h5>
              <p className="text-muted mb-0 fs-12">
                <span className="file-size">{activeFile?.size} Byte</span>,{" "}
                <span className="create-date">
                  {handleValidDate(activeFile?.createdAt)},
                  <small className="text-muted">
                    {" "}
                    {handleValidTime(activeFile?.createdAt)}
                  </small>
                </span>
              </p>
            </div>
            <div>
              <h5 className="fs-12 text-uppercase text-muted mb-3">
                {t("FILE:DESCRIPTION")} :
              </h5>

              <div className="table-responsive">
                <table className="table table-borderless table-nowrap table-sm">
                  <tbody>
                    <tr>
                      <th scope="row">{t("FILE:NAME")} :</th>
                      <td className="file-name">{activeFile?.name}</td>
                    </tr>
                    <tr>
                      <th scope="row" style={{ width: "35%" }}>
                        {t("FILE:TITLE_FILE")} :
                      </th>
                      <td className="file-name">{activeFile?.title}</td>
                    </tr>
                    <tr>
                      <th scope="row">{t("FILE:TYPE")} :</th>
                      <td className="file-type">{activeFile?.type}</td>
                    </tr>
                    <tr>
                      <th scope="row">{t("FILE:SIZE")} :</th>
                      <td className="file-size">{ Number(Number(activeFile?.size) / 1024).toFixed(2)}  KBytes</td>
                    </tr>
                    <tr>
                      <th scope="row">{t("FILE:CREATED")} :</th>
                      <td className="create-date">
                        {handleValidDate(activeFile?.createdAt)},
                        <small className="text-muted">
                          {" "}
                          {handleValidTime(activeFile?.createdAt)}
                        </small>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="mt-auto border-top border-top-dashed py-3">
              <div className="hstack gap-2">
                {activeFile?.itemType !== FileDtoItemTypeEnum.Folder && (
                  <button
                    type="button"
                    className="btn btn-soft-danger w-100"
                    onClick={() => {

                      if(activeFile?.itemType === FileDtoItemTypeEnum.File) {
                        setCurrentPage(1);
                        setPdfModal(true);
                      } else{
                        setVideoModal(true);
                      }
                    }}
                  >
                    <i className="ri-eye-fill fs-16"></i> {t("FILE:VIEW")}
                  </button>
                )}
                {["SUPERADMIN", "MANAGER"].includes(authUser.role) && (
                  <button
                    type="button"
                    className="btn btn-soft-danger w-100 remove-file-overview"
                    onClick={() => onClickDelete(activeFile)}
                    disabled={activeFile?.children?.length > 0}
                  >
                    <i className="ri-close-fill align-bottom me-1"></i>{" "}
                    {t("FILE:DELETE")}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>





        <Modal
          isOpen={videoModal}
          toggle={() => setVideoModal(false)}
          size="xl"
          centered
        >
          <ModalHeader toggle={() => setVideoModal(false)}>
            {activeFile?.name}
          </ModalHeader>
          <ModalBody style={{ minHeight: 600 }}>
            {activeFile?.presignedUrl && (
              <div style={{ textAlign: "center" }}>
                <video width="900" height="600" controls>
                  <source src={activeFile.presignedUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            )}
          </ModalBody>
        </Modal>


        <Modal
          isOpen={pdfModal}
          toggle={() => setPdfModal(false)}
          size="xl"
          centered
        >
          <ModalHeader toggle={() => setPdfModal(false)}>
            {activeFile?.name}
          </ModalHeader>
          <ModalBody style={{ minHeight: 600 }}>
            {activeFile?.presignedUrl && (
              <div style={{ textAlign: "center" }}>
                <Document
                  file={activeFile.presignedUrl}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  <Page pageNumber={currentPage} width={900} />
                </Document>
                <div
                  style={{
                    marginTop: 24,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 16,
                  }}
                >
                  <button
                    className="btn btn-outline-secondary"
                    onClick={goToPrevPage}
                    disabled={currentPage <= 1}
                  >
                    &lt; {t("FILE:PREV") || "Precedente"}
                  </button>
                  <span>
                    {currentPage} / {numPages}
                  </span>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={goToNextPage}
                    disabled={currentPage >= numPages}
                  >
                    {t("FILE:NEXT") || "Successiva"} &gt;
                  </button>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
      </SimpleBar>
    </React.Fragment>
  );
};

export default FileDetail;
